import { Card, CardContent, Grid, Stack } from '@mui/material';
import capitalize from 'lodash/capitalize';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { routeCreator as audienceRouteCreator } from '@occc-app/routes/Audience/utils';
import { Divider, InfoField, LinkChip } from '@occc/ui-design-system';
import { useConfig } from '@occc/config';
import { MessagingCampaignDetailsFragment } from '@occc/graphql';
import { useGetSubBrandByUuid } from '@occc/utils';

import {
  getScheduledDateLabel,
  getScheduledTimeLabel,
  localizeNumber,
} from '../../messaging-campaign-details.utils';
import { getMessagingCampaignTypeTitle } from '../../../../messaging-center.utils';
import { UNIVERSAL_SUB_BRAND_OPTION } from '../../../messaging-campaign-configure/components/target-form/sub-brand-selector.component';

type GeneralInfoProps = {
  status: MessagingCampaignDetailsFragment['status'];
  channelsConfig: MessagingCampaignDetailsFragment['channelsConfig'];
  scheduleAt: MessagingCampaignDetailsFragment['scheduleAt'];
  audience: MessagingCampaignDetailsFragment['audience'];
  subBrandUuid: MessagingCampaignDetailsFragment['subBrandUuid'];
};

export const GeneralInfo = ({
  status,
  channelsConfig,
  scheduleAt,
  audience,
  subBrandUuid,
}: GeneralInfoProps) => {
  const { config } = useConfig();
  const isSubBrandSelectionEnabled = Boolean(config.subBrands?.enabled);
  const subBrand = useGetSubBrandByUuid(subBrandUuid);

  return (
    <Card>
      <CardContent>
        <Stack>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3} md={3}>
              <InfoField label='Delivery Status' value={capitalize(status)} mb={0} />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <InfoField
                label='Channels'
                value={getMessagingCampaignTypeTitle({ channels: channelsConfig, joinSymbol: '&' })}
                mb={0}
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 2 }} />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <InfoField label='Scheduled Date' value={getScheduledDateLabel(scheduleAt)} mb={0} />
            </Grid>
            <Grid item xs={12} sm={3}>
              <InfoField label='Scheduled Time' value={getScheduledTimeLabel(scheduleAt)} mb={0} />
            </Grid>
            <Grid item xs={12} sm={3}>
              <InfoField
                label='Target Audience'
                value={
                  audience ? (
                    <LinkChip
                      label={audience.name}
                      href={audienceRouteCreator.details(audience.uuid)}
                    ></LinkChip>
                  ) : null
                }
                mb={0}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <InfoField
                label='Audience Size'
                value={localizeNumber(audience?.membershipCount || 0)}
                mb={0}
              />
            </Grid>
            {isSubBrandSelectionEnabled && (
              <Grid item xs={12} sm={3}>
                <InfoField
                  label='Sub Brand'
                  value={subBrand?.name || UNIVERSAL_SUB_BRAND_OPTION.label}
                  mb={0}
                />
              </Grid>
            )}
          </Grid>
        </Stack>
      </CardContent>
    </Card>
  );
};
